/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferApprovalRequest } from '../../models/offer-approval-request';
import { OfferApprovalResponse } from '../../models/offer-approval-response';

export interface ApproveOffer$Params {
  offerRequestId: string;
  offerId: string;
      body: OfferApprovalRequest
}

export function approveOffer(http: HttpClient, rootUrl: string, params: ApproveOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferApprovalResponse>>> {
  const rb = new RequestBuilder(rootUrl, approveOffer.PATH, 'post');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
    rb.path('offerId', params.offerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OfferApprovalResponse>>;
    })
  );
}

approveOffer.PATH = '/offers/requests/{offerRequestId}/offers/{offerId}/approve';
